module.exports = __webpack_public_path__ + "static/media/fr-tracing-shot-2.8a8a95ab.png";